export const changeStatusProcessed = state => state.changeStatusProcessed;
export const changeStatusProcessedSuccess = state => state.changeStatusProcessedSuccess;
export const changeStatusProcessedError = state => state.changeStatusProcessedError;
